module.exports = __webpack_public_path__ + "static/img/preview-03.a10e12e6.webp";